module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-500-ab45466987b961535f5d6cf88eb11df8.jpg";